import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSetQuickLinksDataAction } from "../../../actions/dataActions";
import { getQuickLinksData } from "../../../state/selectors";
import { Box, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import NewQuickLink from "./NewQuickLink";
import QuickLinkRow from "./QuickLinkRow";
import PaginationWrapper from "../../Utils/PaginationWrapper";

function QuickLinkView(props) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const onQuickLinkUpdate = (index, newQuickLink) => {
    let newResults = [...data.results];
    let newState = {...data, results: newResults};
    newState.results[index] = newQuickLink;
    dispatch(createSetQuickLinksDataAction(newState));
  };

  const data = useSelector(getQuickLinksData);

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <NewQuickLink />
      <Box>
          <details>
              <summary><Title>Quick Links</Title></summary>
          <Title size="6">
            Note: Quick Links are seen by all site users
          </Title>
          <Table>
            <thead>
              <tr>
                <th>Title</th>
                <th>URL</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {(data.results ?? []).map((value, index) => (
                <QuickLinkRow
                  key={value.id}
                  quickLinkData={value}
                  index={index}
                  endpoint={props.endpoint}
                  onQuickLinkUpdate={onQuickLinkUpdate}
                />
              ))}
            </tbody>
          </Table>
          <PaginationWrapper
            setPage={setPage}
            page={page}
            dataCount={Math.ceil(data.count / 50)}
          />
          </details>
      </Box>
    </div>
  );
}

export default QuickLinkView;
